<script setup lang="ts">
  import HelpDialog from './help-dialog.vue'
  import { searchContextTypesMapping } from '../../utils/global-search-utils'
</script>
<template>
  <HelpDialog>
    <template #trigger>
      <slot name="trigger"></slot>
    </template>
    <!-- <div class="text-base font-medium">How the search works</div> -->
    <div class="text-base font-medium">Shorthands for context searches</div>
    <div class="flex flex-col gap-4 text-sm text-gray-500">
      <div>
        You can use shorthands to quickly switch between different contexts.
      </div>
      <div>
        For example, to search for clients you can use the shorthand "{{
          searchContextTypesMapping.client.prefix
        }}:" by just typing it in the search bar.
      </div>
    </div>
    <div class="grid grid-cols-[auto_auto_minmax(0,1fr)] text-sm text-gray-500">
      <div
        class="text-foreground col-span-1 border-b px-4 py-2 text-xs font-medium"
      >
        Shorthands
      </div>
      <div
        class="text-foreground col-span-1 border-b px-4 py-2 text-xs font-medium"
      >
        Contexts
      </div>
      <div
        class="text-foreground col-span-1 border-b px-4 py-2 text-xs font-medium"
      >
        Description
      </div>
      <template
        v-for="context in Object.values(searchContextTypesMapping).filter(
          (context) => context !== searchContextTypesMapping.global
        )"
        :key="context"
      >
        <div class="col-span-1 border-b px-4 py-2">{{ context.prefix }}:</div>
        <div class="col-span-1 border-b px-4 py-2">{{ context.title }}</div>
        <div class="col-span-1 border-b px-4 py-2">
          {{ context.description }}
        </div>
      </template>
    </div>
  </HelpDialog>
</template>
